import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-send",
  "use": "icon-ib-send-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-send\">\r\n    <path d=\"M935.424 88.576a25.6 25.6 0 0 1 6.0928 26.5216l-283.7504 810.7008a25.6 25.6 0 0 1-47.5648 1.9456L452.096 571.904 96.256 413.7984a25.6 25.6 0 0 1 1.9456-47.5648l810.7008-283.7504a25.6 25.6 0 0 1 26.5216 6.0928z m-433.408 469.6064l128.768 289.792 225.28-643.8912-354.048 354.0992z m317.9008-390.2976L176.0768 393.216l289.7408 128.768 354.0992-354.0992z\" p-id=\"6901\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol